export enum ActiveStates {
  none = 'none',
  doNotDisturb = 'doNotDisturb',
}
